<div class="help-icon-component">
    <button type="button" class="d-flex align-items-center help-icon" title="{{ 'Help' | localize }}" (click)="onHelpClick()">
        <i class="ds-icon-default-circle-question"></i>
    </button>
</div>